import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Company</h3>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#our-packages">Our Packages</a></li>
              <li><a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
              
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Contact</h3>
            <div className="contact-card">
              <div className="contact-row">
                <div className="contact-pill">
                  <FaMapMarkerAlt />
                  <span>CP -1 E-Block Yamunapuram, Bulandshahr</span>
                </div>
              </div>
              <div className="contact-row">
                <a className="contact-pill" href="tel:+919876543210">
                  <FaPhone />
                  <span>+91 90120 52552</span>
                </a>
                <a className="contact-pill" href="mailto:info@ghoomoindia.com">
                  <FaEnvelope />
                  <span>ghoomoindiaa@gmail.com</span>
                </a>
              </div>
            </div>
          </div>

          <div className="footer-section footer-about">
            <h3>About Ghoomo India</h3>
            <p>We craft unforgettable journeys across India with curated experiences, expert guides, and best-in-class support. Your adventure starts here.</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="copyright">
            <p>&copy; Ghoomo India. All Rights Reserved</p>
          </div>
          <div className="social-links">
            {/* <a href="#"><FaFacebook /></a> */}
            {/* <a href="#"><FaTwitter /></a>
            <a href="#"><FaLinkedin /></a> */}
            <a href="https://www.instagram.com/ghoomo.india__?utm_source=ig_web_button_share_sheet&igsh=MWd6Nzc1Z2YxaXAyYw=="><FaInstagram /></a>
            {/* <a href="9012052552"><FaWhatsapp /></a> */}
            <a  href="https://wa.me/919012052552"
                target="_blank"
                rel="noopener noreferrer"
            >
            <FaWhatsapp />
</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;